export const POST_CREATED_ICON_ALT = 'post-created.icon-alt';
export const POST_CREATED_TITLE = 'post-created.title';
export const POST_CREATED_DESCRIPTION = 'post-created.description';
export const POST_CREATED_UPDATES_TIME = 'post-created.updates-time';
export const POST_CREATED_ADD_POST_BUTTON_TEXT = 'post-created.add-post-button-text';
export const POST_CREATED_NAVIGATE_HOME_BUTTON_TEXT = 'post-created.navigate-home-button-text';
